import styled from 'styled-components'
import { BqInput } from '@beeq/react'

export const GlobalSearchButton = styled(BqInput)`
  width: 280px;

  &::part(control){
    height: 48px;
  }
`
